export default {"src":"/_next/static/media/la.97650650.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};